import React, { useState } from "react";
import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import { useSelector } from 'react-redux';
import {useNavigate} from "react-router-dom";
import Grid from '@mui/material/Grid';
import "./style.css";
import axios from "axios";
import Button from '@mui/material/Button';
import { Typography, Dialog, LinearProgress, DialogContent, Box } from "@mui/material";
import TextField from '@mui/material/TextField';
import Autocomplete from "@mui/material/Autocomplete";
import MenuItem from '@mui/material/MenuItem';
import CheckIcon from "@mui/icons-material/Check";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import {Switch} from "@mui/material";
export default function LegalProcess() {
    
    // Add a state variable to hold the selected file
    const [file, setFile] = useState(null);
    const [selectedSales, setSelectedSales] = useState([]);
    const [selectedLokasi, setSelectedLokasi] = useState([]);

    // Handle file selection
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };
    const [imageUrl, setImageUrl] = useState(null); // State to hold the URL of the image
    const navigate = useNavigate();
    const getURL = () => {
        if (!file) {
            alert("Please select a file to upload.");
            return;
        }
    
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/getUploadURL`)
            .then(response => {
                const uploadUrl = response.data.url;
                const key = response.data.key; // assuming this is returned by your API
    
                fetch(uploadUrl, {
                    method: "PUT",
                    headers: {
                        "Content-Type": file.type // Use the type of the selected file
                    },
                    body: file
                })
                .then(response => {
                    if (!response.ok) { throw response }
    
                    // Fetch the file from your backend using the `key`
                    axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${encodeURIComponent(key)}`, {
                        responseType: 'blob' // Tell axios to get the response as a blob
                    })
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'file.pdf'); // or any other extension
                        document.body.appendChild(link);
                        link.click();
                        const file = new Blob([response.data], {type: 'application/pdf'});
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
                    })
                    .catch(error => {
                        console.error("Error during file retrieval:", error);
                    });
                })
                .catch(error => {
                    console.error("Error during file upload:", error);
                });
            });
    }
    
    
    
    const nowstate = useSelector(state => state);
    const [judul,setJudul] = useState();
    const [lokasi, setLokasi]= useState(["Lokasi Sendiri","VO Kokas", "VO G.Serpong", "VO Duta Merlin", "VO Bekasi", "PO Kokas", "PO G.Serpong", "PO Duta Merlin", "PO Bekasi"])
    const [sales, setSales]= useState(["Adnan", "Diva", "Felly", "Reinner"])
    const [checkedState, setCheckedState] = useState({
        'Pendirian PT': false,
        'Pendirian CV': false,
        'PT Perorangan': false,
        'PKP': false,
        'SIUJK': false,
        'IUPJPT': false,
        'Izin Khusus': false,
        'Jual Beli Saham': false,
        'Ganti Pengurus': false,
        'Mutasi Alamat': false,
        'Perubahan KBLI': false,
        'Update OSS RBA': false,
        'Pendaftaran Merek': false,
        // Add more checkboxes as needed
    });

    const handleChange = (event) => {
        setCheckedState({ ...checkedState, [event.target.name]: event.target.checked });
    };
    const [state, setState] = useState({
        gilad: false,
        jason: false,
        antoine: true,
      });

      const [status,setStatus] = useState("PMDN")

      const switchChange = (event) => {
        setSelectedSales("")
        setState({
          ...state,
          [event.target.name]: event.target.checked,
        });
        if(status === "PMDN"){
          setStatus("PMA")
        }else{
          setStatus("PMDN")
        }
      }
      const [loadVisibility, setLoadVisibility] = useState(false)
      const saveLegal = () => {
        setLoadVisibility(true)       
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/saveLegal1`, {
            
          })
          .then(response => {
                    
            
            }).catch(err => {
                console.error(err);
            }); 
        }
      
    return (
        <Grid container>
                <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Grid item  xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
                    <LeftMenu/>
                </Grid>
                <Grid xl={11.5} lg={11.3} md={10.4} sm={8.8} >
                <Grid className="boxshadowclass" position="fixed" width="98%" xs={12} zIndex="100" opacity="1">
                <Header judul="New Legal" isi="Legal Baru"></Header>
                </Grid>
                <Grid sx={{ mt:15}}></Grid>
                                 {/*........................................................Untuk legal Vieww/Dashboard yaaaaaaa .........................................................................................................................................*/}
                                 <>
        {nowstate.user.role==="legal" && (
          <>
                <Grid container sx={{pl:10, pt:5, pb:5}} xs={12}>
                    <Grid xs={12}  sx={{mb:2}}>
                        <Typography ><b>Nama/Judul</b></Typography>
                        <TextField value={judul} onChange={event => setJudul(event.target.value)}/>
                    </Grid>
                    <Grid sm={7} sx={{mb:2}}>
                    <Typography><b>Sales</b></Typography>
                    <Autocomplete
                                    sx={{ width: 360 }}
                                    options={sales}
                                    freeSolo
                                    getOptionLabel={(option) => option}
                                    disableCloseOnSelect
                                    value={selectedSales}
                                    onChange={(event, newValue) => {
                                        setSelectedSales(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Pilih Sales"
                                        placeholder="Pilih Sales"
                                        />
                                    )}
                                    renderOption={(props, option, { selected }) => (
                                        <MenuItem
                                        {...props}
                                        key={option}
                                        value={option}
                                        sx={{ justifyContent: "space-between" }}
                                        >
                                        {option}
                                        {selected ? <CheckIcon color="info" /> : null}
                                        </MenuItem>
                                    )}
                                    />               
                    </Grid>
                    <Grid xs={8}  sx={{mb:5}}>
                        <Typography><b>Jasa</b></Typography>
                        {Object.keys(checkedState).map((checkboxName) => (
                <FormControlLabel
                    key={checkboxName}
                    control={
                        <Checkbox
                            checked={checkedState[checkboxName]}
                            onChange={handleChange}
                            name={checkboxName}
                            color="primary"
                        />
                    }
                    label={checkboxName}
                />
            ))}
                        
                    </Grid>
                    <Grid xs={12} sx={{mb:5}}>
                    <Typography><b>Status Perusahaan:</b></Typography>
                    <FormControlLabel control={<Switch checked={state.gilad} onChange={switchChange} name="gilad"/>} label={status} />
                    </Grid>
                    <Grid sm={7} sx={{mb:2}}>
                    <Typography><b>Lokasi</b></Typography>
                    <Autocomplete
                                    sx={{ width: 360 }}
                                    options={lokasi}
                                    freeSolo
                                    getOptionLabel={(option) => option}
                                    disableCloseOnSelect
                                    value={selectedLokasi}
                                    onChange={(event, newValue) => {
                                        setSelectedLokasi(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Pilih Status Lokasi"
                                        placeholder="Pilih Status Lokasi"
                                        />
                                    )}
                                    renderOption={(props, option, { selected }) => (
                                        <MenuItem
                                        {...props}
                                        key={option}
                                        value={option}
                                        sx={{ justifyContent: "space-between" }}
                                        >
                                        {option}
                                        {selected ? <CheckIcon color="info" /> : null}
                                        </MenuItem>
                                    )}
                                    />               
                    </Grid>
                    <Grid container justifyContent="flex-end" xs={7}>
                    <Button onClick={() =>{saveLegal()}} variant="contained">Create</Button>
                    </Grid>
                </Grid>
                </>)}</>
        
        
            </Grid>
        </Grid>
    );
}
